import "./style/personal-campaigns.scss"

import { showPersonalCampaignPopup } from "@app/store/app/appActions"
import { RootState } from "@app/types"
import {
    PersonalCampaign,
    userHelpers,
    SapCrmCampaign,
    bonusCampaignActions,
} from "@ng-mw/shared-react-components/user"
import React, { useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import reusableHeartIcon from "@resources/icons/reusableHeart"
import packageIcon from "@resources/icons/package"
import menyPercentWhite from "@ng-mw/reol/icons/menyPercentWhite"

// Components
import Container from "@modules/shared/Container"
import Icon from "@ng-mw/reol/components/Icon"

interface PersonalCampaignsProps {
    showTitle?: boolean
    showEmptyCard?: boolean
    campaigns?: SapCrmCampaign[]
    showAsUnavailableBlurred?: boolean
}

const PersonalCampaigns = ({
    showTitle = false,
    showEmptyCard = false,
    campaigns,
    showAsUnavailableBlurred = false,
}: PersonalCampaignsProps) => {
    const dispatch = useDispatch<any>()
    const userIsLoggedIn = useSelector((state: RootState) => state.user.loginLevel > 0)
    const { data } = useSelector((state: RootState) => state.bonusCampaign)
    const { isOrganization } = useSelector((state: RootState) => state.user.data.household)

    useEffect(() => {
        if (userIsLoggedIn) {
            dispatch(bonusCampaignActions.getRelevantBonuses())
        }
    }, [dispatch, userIsLoggedIn])

    const { filteredCampaigns } = useMemo(() => {
        let filteredCampaigns: SapCrmCampaign[] = []

        if (campaigns?.length) {
            filteredCampaigns = campaigns
        } else {
            if (Array.isArray(data) && data.length) {
                filteredCampaigns = userHelpers.getActivePersonalCampaigns(data)
            }
        }

        return {
            filteredCampaigns,
        }
    }, [data, campaigns])

    if (showAsUnavailableBlurred) {
        return (
            <Container className="personal-campaigns__unavailable">
                <Icon
                    className="personal-campaigns__unavailable-heart-left"
                    icon={reusableHeartIcon}
                    noSize
                />
                <Icon
                    className="personal-campaigns__unavailable-heart-right"
                    icon={reusableHeartIcon}
                    noSize
                />

                <Icon
                    className="personal-campaigns__unavailable-icon"
                    icon={packageIcon}
                    noSize
                />
                <span className="personal-campaigns__unavailable-text">
                    Bli MENY MER-kunde og få 10% Trumf-bonus på neste handel som velkomstgave
                </span>
            </Container>
        )
    }

    if (!userIsLoggedIn) {
        return null
    }

    const personalCampaignTitle = `Dine personlige goder (${filteredCampaigns?.length})`

    if (isOrganization || (!filteredCampaigns?.length && !showEmptyCard)) return null

    if (!filteredCampaigns?.length && showEmptyCard)
        return (
            <Container title={personalCampaignTitle}>
                <div className="personal-campaign-empty">
                    <Icon
                        className="personal-campaign-empty__icon"
                        icon={menyPercentWhite}
                        size={{ width: "30px", height: "30px" }}
                    />
                    <p>Akkurat nå har du ingen personlige goder.</p>
                </div>
            </Container>
        )

    const handleClick = (campaign: SapCrmCampaign) => {
        dispatch(showPersonalCampaignPopup(campaign))
    }

    if (filteredCampaigns?.length === 1)
        if (showTitle) {
            return (
                <Container
                    className="personal-campaigns"
                    title={showTitle ? personalCampaignTitle : ""}
                >
                    {filteredCampaigns.map((campaign: SapCrmCampaign) => (
                        <button
                            onClick={() => handleClick(campaign)}
                            key={campaign.kampanjeId}
                        >
                            <PersonalCampaign campaign={campaign} />
                        </button>
                    ))}
                </Container>
            )
        } else {
            return filteredCampaigns?.map((campaign: SapCrmCampaign) => (
                <button
                    onClick={() => handleClick(campaign)}
                    key={campaign.kampanjeId}
                >
                    <PersonalCampaign campaign={campaign} />
                </button>
            ))
        }
    return (
        <Container
            className="personal-campaigns"
            title={showTitle ? personalCampaignTitle : ""}
        >
            <div className="personal-campaigns__list">
                <Swiper
                    spaceBetween={16}
                    slidesOffsetAfter={16}
                    slidesOffsetBefore={16}
                    slidesPerView={1.2}
                >
                    {filteredCampaigns.map((campaign: SapCrmCampaign) => (
                        <SwiperSlide
                            key={`slide_${campaign.kampanjeId}`}
                            aria-labelledby={campaign.langBeskrivelse}
                        >
                            <button onClick={() => handleClick(campaign)}>
                                <PersonalCampaign campaign={campaign} />
                            </button>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </Container>
    )
}
export default PersonalCampaigns
